import {
  Component,
  OnInit,
  Input,
  HostBinding,
  OnDestroy,
  HostListener,
  Directive,
  Renderer2,
  ElementRef,
  ChangeDetectorRef
} from "@angular/core";
//import { MediaObserver } from "@angular/flex-layout";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { MatchMediaService } from "../../services/match-media.service";
import { MatxSidebarHelperService } from "./matx-sidebar-helper.service";

@Component({
  selector: "matx-sidebar",
  templateUrl: "./matx-sidebar.component.html",
  styleUrls: ["./matx-sidebar.component.scss"]
})
export class MatxSidebarComponent implements OnInit, OnDestroy {
  // Name
  @Input()
  name: string = '';

  // right
  @Input()
  @HostBinding("class.position-right")
  right: boolean = false;

  // Open
  @HostBinding("class.open")
  opened: boolean= false;

  @HostBinding("class.sidebar-locked-open")
  sidebarLockedOpen: boolean= false;

  //mode
  @HostBinding("class.is-over")
  isOver: boolean= false;

  private backdrop: HTMLElement | null = null;

  private lockedBreakpoint = "gt-sm";
  private unsubscribeAll: Subject<any>;

  constructor(
    private matchMediaService: MatchMediaService,
    //private mediaObserver: MediaObserver,
    private sidebarHelperService: MatxSidebarHelperService,
    private _renderer: Renderer2,
    private _elementRef: ElementRef,
    private cdr: ChangeDetectorRef
  ) {
    this.unsubscribeAll = new Subject();
  }

  ngOnInit() {
    this.sidebarHelperService.setSidebar(this.name, this);

    // JEK
    //if (this.mediaObserver.isActive(this.lockedBreakpoint)) {
    //  this.sidebarLockedOpen = true;
    //  this.opened = true;
    //} else {
    this.sidebarLockedOpen = false;
    this.opened = false;
    //}

    //this.matchMediaService.onMediaChange
    //  .pipe(takeUntil(this.unsubscribeAll))
    //  .subscribe(() => {
    //    // console.log("medua sub");
    //    if (this.mediaObserver.isActive(this.lockedBreakpoint)) {
    //      this.sidebarLockedOpen = true;
    //      this.opened = true;
    //    } else {
    //      this.sidebarLockedOpen = false;
    //      this.opened = false;
    //    }
    //  });
  }

  open() {
    this.opened = true;
    if (!this.sidebarLockedOpen && !this.backdrop) {
      this.showBackdrop();
    }
  }

  close() {
    this.opened = false;
    this.hideBackdrop();
  }

  toggle() {
    if (this.opened) {
      this.close();
    } else {
      this.open();
    }
  }

  showBackdrop() {
    this.backdrop = this._renderer.createElement("div")!;
    if (!this.backdrop) {
      return;
    }

    this.backdrop.classList.add("matx-sidebar-overlay");

    this._renderer.appendChild(
      this._elementRef.nativeElement.parentElement,
      this.backdrop
    );

    // Close sidebar onclick
    this.backdrop.addEventListener("click", () => {
      this.close();
    });

    this.cdr.markForCheck();
  }

  hideBackdrop() {
    if (this.backdrop) {
      this.backdrop.parentNode!.removeChild(this.backdrop);
      this.backdrop = null;
    }

    this.cdr.markForCheck();
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(1);
    this.unsubscribeAll.complete();
    this.sidebarHelperService.removeSidebar(this.name);
  }
}

@Directive({
  selector: "[matxSidebarToggler]"
})
export class MatxSidebarTogglerDirective {
  @Input("matxSidebarToggler")
  public id: any;

  constructor(private matxSidebarHelperService: MatxSidebarHelperService) {}

  @HostListener("click")
  onClick() {
    this.matxSidebarHelperService.getSidebar(this.id).toggle();
  }
}
